import { useCallback } from 'react';

import { PatientSimple, PatientSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { Direction, paginations } from '@dreryk/command-query-ws-client';
import { Slot } from '@dreryk/watermelon';

export const usePatientSimpleSearchCreator = (
   searchText: string | null
): (() => CqrsQueryPerformResult<PatientSimple[]>) => {
   return useCallback(
      async () =>
         performCqrsQuerySearch<PatientSimple>(() => {
            const query = new PatientSimpleQuery();
            query.freeformCriteria = Slot.emptyIfNull(searchText);
            return query;
         }, paginations.all<PatientSimple>().orderedBy('lastName', Direction.ASCENDING).orderedBy('firstName', Direction.ASCENDING).orderedBy('externalIdentifier', Direction.ASCENDING)),
      [searchText]
   );
};
